/**
 * Normalise text for Vietnamese-friendly searching: strips diacritics (so the two
 * valid tone-mark placements "Thùy" / "Thuỳ" become the same), maps đ → d,
 * lower-cases and collapses runs of whitespace (stored names sometimes contain
 * double or trailing spaces).
 */
export const normalizeSearchText = (value: unknown): string =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

/**
 * True when every word typed in the search box appears somewhere in the text,
 * ignoring diacritics, case, word order and extra spaces. Example: the query
 * "nguyễn thuỳ trang" matches "Nguyễn Thị Thùy  Trang". An empty query matches.
 */
export const matchesSearch = (haystack: unknown, query: unknown): boolean => {
  const tokens = normalizeSearchText(query).split(' ').filter(Boolean);
  if (tokens.length === 0) {
    return true;
  }
  const text = normalizeSearchText(haystack);
  return tokens.every((token) => text.includes(token));
};
